import React, { useEffect } from "react";
import { useState } from "react";
import selectArrow from "src/assets/images/selectArrow.svg";
import selectArrowSmall from "src/assets/images/selectArrowSmall.svg";
import cn from "classnames";
import styled from "styled-components";

interface ISelectProps {
  id?: string;
  size?: string;
  defaultValue?: string;
  options: {
    value: string;
    name: string;
  }[];
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select = (props: ISelectProps) => {
  const [hasValue, setValue] = useState(props.defaultValue || "");

  useEffect(() => {
    setValue(props.defaultValue!);
  }, [props]);

  return (
    <SelectWrap className={cn(props.size)}>
      <SelectSet value={hasValue} onChange={props.onChange} id={props.id}>
        {props.options.map((option, k) => (
          <option key={k} value={option.value}>
            {option.name}
          </option>
        ))}
      </SelectSet>
    </SelectWrap>
  );
};

const SelectWrap = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  background: ${({ theme }) => theme.color.bgPrimary};
  &::after {
    position: absolute;
    top: 50%;
    right: 20px;
    content: "";
    display: block;
    width: 15px;
    height: 9px;
    margin-top: -4px;
    background: url(${selectArrow}) no-repeat 0 0;
  }
  &.small {
    height: 32px;
    &::after {
      right: 5px;
      width: 24px;
      height: 24px;
      margin-top: -12px;
      background: url(${selectArrowSmall}) no-repeat 0 0;
    }
    > select {
      padding: 0 34px 0 15px;
    }
  }
`;
const SelectSet = styled.select`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 40px 0 15px;
  border: none;
  background: transparent;
  color: #001827;
  font-size: 16px;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &:focus {
    outline: none;
  }
`;

export default Select;
